import {
  filterStatutsForContext,
  filterStatutsForMonth,
  isRefActiveInMonth,
} from './kkpStatutUtils';

export const MAG_SUMMER_MONTHS = [7, 8];
export const MAG_SUMMER_CANONICAL_MONTH = 7;
export const MAG_SUMMER_LABEL = 'Juillet-Août';
export const MAG_WINTER_CANONICAL_MONTH = 12;
export const MAG_WINTER_LABEL = 'Décembre-Janvier';

export function isMagSummerMonth(month) {
  return Number(month) === 7 || Number(month) === 8;
}

export function isMagWinterMonth(month) {
  return Number(month) === 1 || Number(month) === MAG_WINTER_CANONICAL_MONTH;
}

export function normalizeMagMois(mois) {
  return Number(mois) === 8 ? MAG_SUMMER_CANONICAL_MONTH : Number(mois);
}

/** Août → juillet (même année). Janvier → décembre de l'année précédente. */
export function canonicalMagPeriod(annee, mois) {
  const year = Number(annee);
  const month = Number(mois);
  if (month === 8) {
    return { annee: year, mois: MAG_SUMMER_CANONICAL_MONTH };
  }
  if (month === 1) {
    return { annee: year - 1, mois: MAG_WINTER_CANONICAL_MONTH };
  }
  return { annee: year, mois: month };
}

export function isRefActiveInMagMonth(ref, year, month) {
  if (!ref || ref.active === false) {
    return false;
  }
  if (isMagSummerMonth(month)) {
    return isRefActiveInMonth(ref, year, 7) || isRefActiveInMonth(ref, year, 8);
  }
  if (isMagWinterMonth(month)) {
    const period = canonicalMagPeriod(year, month);
    return isRefActiveInMonth(ref, period.annee, 12) || isRefActiveInMonth(ref, period.annee + 1, 1);
  }
  return isRefActiveInMonth(ref, year, month);
}

export function filterRefsForMagMonth(refs, year, month) {
  if (!year || !month) {
    return refs ?? [];
  }
  return (refs ?? []).filter((ref) => isRefActiveInMagMonth(ref, year, month));
}

export function filterRefsForMagContext(refs, year, month) {
  if (year && month) {
    return filterRefsForMagMonth(refs, year, month);
  }
  if (year) {
    return (refs ?? []).filter((ref) =>
      Array.from({ length: 11 }, (_, index) => index + 2).some((m) => isRefActiveInMagMonth(ref, year, m)),
    );
  }
  return refs ?? [];
}

export function filterStatutsForMagContext(statuts, year, month) {
  return filterRefsForMagContext(statuts, year, month);
}

export function filterStatutsForMagMonth(statuts, year, month) {
  return filterRefsForMagMonth(statuts, year, month);
}
